module.exports = __webpack_public_path__ + "img/circle.7e028ed0.png";